var modules_59ffffaf = {"wrapper":"CommonError_module_wrapper__a161ed5c"};
import "../../../assets/esm/components/CommonError/CommonError~BXoB0u0_.css";

export { modules_59ffffaf as default };
//# sourceMappingURL=CommonError.module.less.js.map
